import React, { useEffect, useState } from 'react'
import { View, Text, ActivityIndicator, StyleSheet } from 'react-native'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigation } from '@react-navigation/native'
import PropertySearch from '../../../components/maintainance/PropertySearch'

import { showErrorToast } from '../../tenants/tenantOnboarding/helpers'
import { getCatogoriesTypes, getFlow, getRoomTypes } from '../../../redux/action/maintenance.actions'
import drawerHoc from '../../../components/drawerHOC/DrawerHOC'
import AddNewIssueModal from '../../../components/maintainance/AddNewIssueModal'
import IssueFormStep from '../../../components/maintainance/IssueFormStep'
import { Pagination } from '@mui/material'
import TableShimmer from '../../../components/maintainance/TableShimmer'

const NewIssueScreen = (props: any) => {
  const navigation = useNavigation()
  const dispatch = useDispatch()

  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [loading, setLoading] = useState(false)
  const [openModal, setOpenModal] = useState(false)

  const { flowList, flowListTotalCount } = useSelector(
    (state) => state.maintenance
  )
  const pageCount = Math.ceil(flowListTotalCount / 10)
  const getFlo = async () => {
    setOpenModal(false)
    try {
      setLoading(true)
      await dispatch(
        getFlow({
          offset: (page - 1),
          limit: pageSize,
          sortBy: 'date_opened',
          sortOrder: 'DESC'
        })
      )
    } catch (e) {
      showErrorToast('Failed to fetch properties')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    dispatch(getRoomTypes())
    dispatch(getCatogoriesTypes())
  }, [])

  useEffect(() => {
    getFlo()
  }, [page, pageSize])

  const handleView = (flow) => {
    if (props?.onViewFlow) {
      props.onViewFlow(flow)
      return
    }

    navigation.navigate('New_issues', {
      id: flow?.openflow_id
    })
  }
  const handlePageChanges = (event, value) => {
    setPage(value)
  }
  return (
    <View style={styles.container}>

      {loading ? (
      <TableShimmer rows={6} />
      ) : (
        <PropertySearch
          flos={flowList}
          flototal={flowListTotalCount}
          onView={handleView}
          refresh={getFlo}
          onAdd={() => setOpenModal(true)}
        />
      )}
      <Pagination
        style={{ alignSelf: "center", marginTop: 10 }}
        count={pageCount} page={page} onChange={handlePageChanges} color='primary' />
      {openModal ? <AddNewIssueModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        onIssueAdded={getFlo}
        refresh={getFlo}
      /> : null}


    </View>
  )
}

const WrappedComponent = drawerHoc({
  Component: NewIssueScreen,
  showBackButton: true,
  customWidth: "70%"
});

export default function ExportComponent(props: any) {
  if (props?.showCompletePage === false) {
    return <NewIssueScreen {...props} />
  }

  return <WrappedComponent {...props} />
}

const styles = StyleSheet.create({
  container: { flex: 1, },
  title: { fontSize: 20, fontWeight: '700' },
  subtitle: { fontSize: 14, marginBottom: 20 }
})
